export enum PhoneInterviewStatus {
  SCHEDULED_FOR_CANDIDATE_QUALIFICATION,
  REJECTED,
  RECOMMENDED_TO_BUSINESS_UNIT,
  CONTACTED
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/enums/phone-interview-status.enum.ts